import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_LOYALTY_PRIZE_DETAIL = gql`
  query getLoyaltyPrizeDetail($slugName: String!) {
    getLoyaltyPrizeDetail(slugName: $slugName) {
      isAuth
      slugName
      monthly {
        month
        claimed
      }
      latestClaims {
        code
        link
        usedAt
      }
      windowStart
      windowEnd
    }
  }
`;

const getLoyaltyPrizeDetail = async (slugName) => {
  try {
    const result = await client.query({
      query: GET_LOYALTY_PRIZE_DETAIL, variables: { slugName }, errorPolicy: 'all', fetchResults: true, fetchPolicy: 'no-cache',
    }).catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyPrizeDetail Query Error: ${queryError}`);
      return null;
    });
    return result && result.data ? result.data.getLoyaltyPrizeDetail : null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyPrizeDetail Error: ${error}`);
    return null;
  }
};

export default getLoyaltyPrizeDetail;
